import { isUndefined } from 'lodash';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { EGabinetNews } from './NewsCard.hooks';
import { StyledNewsCardListElement } from './NewsCardListElementContent.styled';
import { NewsCardListElementNewsTagLoader } from './NewsCardListElementNewsTag.loader';
import { NewsCardListElementContent } from './NewsCardListElementContent';

type NewsCardListElementProps = { egabinetNews: EGabinetNews };

export const NewsCardListElement = (props: NewsCardListElementProps): JSX.Element => {
   return (
      <StyledNewsCardListElement {...appendTestableElementAttributes('newsItem')}>
         {isUndefined(props.egabinetNews.tagId) ? (
            <NewsCardListElementContent egabinetNews={props.egabinetNews} />
         ) : (
            <NewsCardListElementNewsTagLoader tagId={props.egabinetNews.tagId.toString()}>
               {({ newsCardListElementTag }) => (
                  <NewsCardListElementContent
                     egabinetNews={props.egabinetNews}
                     newsCardListElementTag={newsCardListElementTag}
                  />
               )}
            </NewsCardListElementNewsTagLoader>
         )}
      </StyledNewsCardListElement>
   );
};
